export default "__VITE_ASSET__GxI_YRrM__"